<template>
  <div class="card card-custom">
    <div class="card-body p-0">
      <div
        class="wizard wizard-1"
        id="kt_wizard_v1"
        data-wizard-state="step-first"
        data-wizard-clickable="true"
      >
        <WizardNav></WizardNav>
        <div class="row justify-content-center my-10 px-8 my-lg-15 px-lg-10">
          <div class="col-xl-12 col-xxl-12">
            <!--begin: Wizard Form-->
            <v-form ref="form" class="form" id="kt_form">
              <FormCourseStep1 
              v-model="formData" 
              @submit="submit" 
              mode="add"
              ></FormCourseStep1>
              <FormCourseStep2 v-model="formData"></FormCourseStep2>
              <FormCourseStep3 v-model="formData"></FormCourseStep3>
              <WizardActions @submit="submit"></WizardActions>
            </v-form>
          </div>
        </div>
      </div>
    </div>
    <v-dialog v-model="loading" fullscreen full-width>
      <v-container fluid fill-height>
        <v-layout justify-center align-center>
          <v-progress-circular indeterminate color="pink">
          </v-progress-circular>
        </v-layout>
      </v-container>
    </v-dialog>
  </div>
</template>

<style lang="scss">
  @import "@/assets/sass/pages/wizard/wizard-1.scss";
</style>  

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import KTUtil from "@/assets/js/components/util";
import KTWizard from "@/assets/js/components/wizard";

import FormCourseStep1 from "@/components/admin/course/forms/wizard/formCourseStep1.vue";
import FormCourseStep2 from "@/components/admin/course/forms/wizard/formCourseStep2.vue";
import FormCourseStep3 from "@/components/admin/course/forms/wizard/formCourseStep3.vue";
import WizardNav from "@/components/admin/video/forms/wizard/wizardNav.vue";
import WizardActions from "@/components/wizard/wizardActions.vue";

import Api from "@/core/services/api.service";
import Swal from "sweetalert2";

export default {
  name: "addCourse",
  
  components: {
    FormCourseStep1,
    FormCourseStep2,
    FormCourseStep3,
    WizardActions,
    WizardNav,
  },

  data: () => ({
    loading: false,
    formData: {
      posterFile: null,
      title: "",
      titleEN: "",
      description: "",
      descriptionEN: "",
      isVisible: true,
      keywords: {
        visibleEN: [],
        visibleFR: [],
        invisibleEN: [],
        invisibleFR: [],
      },
      theme: [],
    },
  }),

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Administration", route: "gestionContenus" },
      { title: "Gestions des contenus", route: "gestionContenus" },
      { title: "Créer un parcours" },
    ]);
    // Initialize form wizard
    const wizard = new KTWizard("kt_wizard_v1", {
      startStep: 1, // initial active step number
      clickableSteps: true, // allow step clicking
    });

    // Validation before going to next page
    wizard.on("beforeNext", function(/*wizardObj*/) {
      // validate the form and use below function to stop the wizard's step
      // wizardObj.stop();
    });

    // Change event
    wizard.on("change", function(/*wizardObj*/) {
      setTimeout(() => {
        KTUtil.scrollTop();
      }, 500);
    });
  },
    methods: {
    submit: async function() {
      if (!this.$refs.form.validate()) {
        Swal.fire({
          //Swal = Sweet Alert
          title: "Impossible de créer le parcours",
          text:
            "Vérifier les champs du formulaire avant de pouvoir créer le parcours. Certaines informations sont obligatoires et signalées par un astérisque (*)",
          icon: "warning",
          confirmButtonClass: "btn btn-secondary",
        });
      } else {
        const keywords = await Promise.all([
          ...this.formData.keywords.visibleFR.map((k) =>
            typeof k === "string"
              ? Api.post("keywords", {
                  name: k,
                  lang: "FR",
                  isVisible: true,
                }).then((res) => res.data)
              : Promise.resolve(k)
          ),
          ...this.formData.keywords.visibleEN.map((k) =>
            typeof k === "string"
              ? Api.post("keywords", {
                  name: k,
                  lang: "EN",
                  isVisible: true,
                }).then((res) => res.data)
              : Promise.resolve(k)
          ),
          ...this.formData.keywords.invisibleFR.map((k) =>
            typeof k === "string"
              ? Api.post("keywords", {
                  name: k,
                  lang: "FR",
                  isVisible: false,
                }).then((res) => res.data)
              : Promise.resolve(k)
          ),
          ...this.formData.keywords.invisibleEN.map((k) =>
            typeof k === "string"
              ? Api.post("keywords", {
                  name: k,
                  lang: "EN",
                  isVisible: false,
                }).then((res) => res.data)
              : Promise.resolve(k)
          ),
        ]);

        let response;
        try {
          this.loading = true;
          response = await Api.post("courses", {
            title: this.formData.title,
            description: this.formData.description,
            keywords: keywords.map((k) => k["@id"]), //Boucle sur tout les keywords pour n'envoyer que les @id pour Api platform qui ne comprends que les IRIs et pas l'objet entier
            theme: this.formData.theme[0]["@id"],
            isVisible: this.formData.isVisible,
          }, { headers: { 'Accept-Language': 'fr_FR' } });
          await Api.patch('courses', response.data.id, {
            title: this.formData.titleEN,
            description: this.formData.descriptionEN
          }, { headers: { 'Accept-Language': 'en_GB' } });
          this.loading = false;
          Swal.fire({
             title: "",
             text: "Le parcours a été crée.",
             icon: "success",
             confirmButtonClass: "btn btn-secondary",
          });
          this.$router.push({ name: "gestionContenus", query: {
            selected: 'tab-courses',
          }, });
        } catch (error) {
          //Dans le cas où la première requête à échoué.
          Swal.fire({
            title: "",
            text: "Une erreur est survenue lors de la création du parcours",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
          });
          this.loading = false;

          return;
        }

        //On construit le formData pour y mettre les fichiers, qui seront envoyés
        //seulement lorsque la requête si dessus aura réussi.
        // var bodyFormData = new FormData();
        // //bodyFormData.append("poster", this.formData.posterFile);

        // try {
        //   await 
        //   Api.post(`courses/${response.data.id}`, bodyFormData);
        //   this.loading = false;
        //   Swal.fire({
        //     title: "",
        //     text: "Le parcours a été crée.",
        //     icon: "success",
        //     confirmButtonClass: "btn btn-secondary",
        //   });

        //   this.$router.push({ name: "gestionContenus", query: {
        //           selected: 'tab-courses',
        //         }, });
        // } catch (error) {
        //   this.loading = false;

        //   Swal.fire({
        //     title: "",
        //     text:
        //       "Le parcours a bien été crée, cependant une erreur est survenue lors de l'upload de son image d'illustration. Vous pouvez modifier le parcours pour l'ajouter.",
        //     icon: "error",
        //     confirmButtonClass: "btn btn-secondary",
        //   });
        //   this.$router.push({ name: "gestionContenus", query: {
        //           selected: 'tab-courses',
        //         }, });
        // }
      }
    },
  },
};
</script>
